import { Constants } from '../data';
import { getLevelCount } from '../data/CurriculumManager';

const initialState = {
  levelId: 1,
  highestLevelEarned: 0,
  hasSeenOnboarding: false,
};

const sessionReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'CHANGE_CURRENT_LEVEL':
      return {
        ...state,
        levelId: action.payload.level > getLevelCount() ? getLevelCount() : action.payload.level,
      };
    case 'SET_HAS_SEEN_ONBOARDING':
      return {
        ...state,
        hasSeenOnboarding: true,
      };
    case 'SET_HIGHEST_LEVEL_EARNED':
      return {
        ...state,
        highestLevelEarned: action.payload.level,
      };
    default:
      return state;
  }
};

export default sessionReducer;
